import { render, staticRenderFns } from "./ExibirLegislacaoModal.vue?vue&type=template&id=26c2bb55&"
import script from "./ExibirLegislacaoModal.vue?vue&type=script&lang=js&"
export * from "./ExibirLegislacaoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports